export default "__VITE_ASSET__B_z2db6c__"